// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pop-enter-active[data-v-53da4988]{animation:pop-in-53da4988 .3s}.pop-leave-active[data-v-53da4988]{animation:pop-in-53da4988 .3s reverse}@keyframes pop-in-53da4988{0%{transform:scale(0)}50%{transform:scale(1.1)}to{transform:scale(1)}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
